/*-----------------------------------------------------------------
- Footer
-----------------------------------------------------------------*/
export default {
    contact_title   : 'راه‌های ارتباطی با ما',
    socials_title   : 'ما را در شبکه‌های اجتماعی دنبال کنید',
    trust_seal_title: 'با خیال راحت به ما اعتماد کنید',
    powered_by_text : 'قدرت گرفته از کوارکینو',
    show_on_map     : 'دیدن آدرس روی نقشه',
};
